import { createEntityAdapter } from '@reduxjs/toolkit'

import { rootApi } from 'root-api'

const getProfilesUrl = ({ scopeType, scopeId }) => {
  switch (scopeType) {
    case 'user_single':
      return `/api/users/${scopeId}/event_types`
    case 'page_single':
      return `/api/teams/${scopeId}/event_types`
    case 'user_group':
      return `/api/user_groups/${scopeId}/event_types`
    default:
      return '/api/users/me/event_types'
  }
}

const profilesAdapter = createEntityAdapter({
  selectId: (instance) => `${instance.type}::${instance.id}`
})

const api = rootApi.enhanceEndpoints({ addTagTypes: ['PROFILE_EVENT_TYPE_LIST'] }).injectEndpoints({
  endpoints: (build) => ({
    fetchProfiles: build.query({
      query: ({ scopeType, scopeId, queryParams }) => ({
        url: getProfilesUrl({ scopeType, scopeId }),
        params: {
          scope: scopeType,
          ...queryParams
        }
      }),
      transformResponse: (baseQueryReturnValue) => {
        const results = baseQueryReturnValue.results.map((profile) => (
          { ...profile, eventTypeIds: profile.event_types.map(({ uuid }) => uuid) })
        )

        return {
          pagination: baseQueryReturnValue.pagination,
          results: profilesAdapter.setAll(profilesAdapter.getInitialState(), results)
        }
      },
      providesTags: ['PROFILE_EVENT_TYPE_LIST'],
      keepUnusedDataFor: 0,
      extraOptions: {
        transformResponse: false
      }
    })
  })
})

export const {
  useFetchProfilesQuery
} = api
